import React from "react";

/**
 * Bula Golf brand logo — uses the dad-silhouette PWA icon.
 * Sizes default to 36px (same as the previous Flag-in-a-box mark).
 */
export function BulaLogo({ size = 36, className = "", rounded = "rounded-xl" }) {
  return (
    <img
      src="/icon-192.png"
      alt="Bula Golf"
      width={size}
      height={size}
      data-testid="bula-logo"
      className={`${rounded} object-cover shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
